import template from './search-bar.html'

export let searchBar = {
  bindings: {
    onChange: '&',
    searchIcon: '<',
    iconSize: '<',
    barStyle: '<',
    opacity: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['CssClasses',
  function searchBarCtrl (CssClasses) {
    const vm = this
    vm.search = CssClasses.icons.search
    vm.$onInit = () => {
      vm.transparent = vm.opacity ? ['transparent', 'opacity-4'] : ''
      vm.iconClasses = [vm.search, 'i-' + vm.iconSize, vm.transparent[1]]
      vm.barClasses = [vm.barStyle, vm.transparent[0]]
    }
  }
]}




// WEBPACK FOOTER //
// ./src/app/u-faculty/components/search-bar.js